import { useOfficeComponentContext } from '@office-start/component-context-service';
import { useUserProfile, useUserProfileMetricsKey, } from '@office-start/harmony-data-service';
import { OfficeWorkload } from '@office-start/officehome-types';
import { useWebStorageGetUserItem } from '@office-start/web-storage-utility';
import { useMemo } from 'react';
export var useTeachingUIGetUserData = function () {
    var userProfileMetricsKey = useUserProfileMetricsKey();
    var userDataWeb = useUserProfile();
    var userDataHWA = useWebStorageGetUserItem(userProfileMetricsKey).data;
    var officeComponentContext = useOfficeComponentContext().data;
    return useMemo(function () {
        if ((officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload) === OfficeWorkload.Hwa) {
            return !userDataHWA ? undefined : userDataHWA;
        }
        return !userDataWeb ? null : userDataWeb;
    }, [officeComponentContext === null || officeComponentContext === void 0 ? void 0 : officeComponentContext.workload, userDataHWA, userDataWeb]);
};
//# sourceMappingURL=useTeachingUIGetUserData.js.map